import { useOpenItemsPaging } from './useOpenItemsPaging';
import styles from './Payments.module.css';
import { Button } from '../../components/ui/Button';
import { useTranslation } from 'react-i18next';

export function OpenItemsBrowser({ paging }: { paging: ReturnType<typeof useOpenItemsPaging> }) {
  const { t } = useTranslation();
  return (
    <div>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          void paging.searchOrders();
        }}
        className={`${styles.actions} ${styles.orderSearch}`}
      >
        <label className={styles.field}>
          {t('payments.openItemsBrowser.searchLabel')}
          <input
            aria-label={t('payments.openItemsBrowser.searchLabel')}
            placeholder={t('payments.openItemsBrowser.searchPlaceholder')}
            maxLength={128}
            value={paging.search}
            onChange={(event) => paging.setSearch(event.target.value)}
          />
        </label>
        <Button variant="secondary" size="sm" disabled={paging.pending} type="submit">
          {t('payments.openItemsBrowser.searchSubmit')}
        </Button>
      </form>
      <div className={styles.footer}>
        <span>
          {t('payments.openItemsBrowser.showing', { shown: paging.items.orders.length, total: paging.items.totalCount })}
        </span>
        {paging.hasMore && (
          <Button
            variant="secondary"
            size="sm"
            disabled={paging.pending}
            onClick={() => void paging.loadMore()}
          >
            {paging.pending ? 'Loading…' : 'Load more'}
          </Button>
        )}
      </div>
      {paging.error && (
        <div role="alert" className={styles.error}>
          {paging.error}
        </div>
      )}
    </div>
  );
}
